import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ClientApi, SystemConfig } from '../client-api.service';
import { shareReplay, tap } from 'rxjs/operators';
import { GLOBAL, IGlobalSettings } from '../shared/global-settings';

@Injectable({
  providedIn: 'root',
})
export class SystemConfigService {
  
  constructor(@Inject(GLOBAL) public globalSettings: IGlobalSettings,   
              private clientApi: ClientApi) {
    this.setSystemConfig();
  }
    
    private systemConfig = new BehaviorSubject<SystemConfig | undefined>(undefined);
    readonly systemConfig$ = this.systemConfig.asObservable();

    setSystemConfig() {
      this.getSystemConfig()      
          .pipe(
            tap((c) => {
                this.globalSettings.monthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                this.globalSettings.actBudLedgerName = c!.actBudLedgerName!;
                this.globalSettings.budgetYear = c!.budgetYear!;
                this.globalSettings.defaultCalculationView = c!.defaultCalculationView!;
                this.globalSettings.fpLedgerName = c!.fpLedgerName!;
                this.globalSettings.payrollCashPayDaysPerMonth = c!.payrollCashPayDaysPerMonth!.replace(/\s/g, '').split(',').map(item => Number(item));
                this.globalSettings.payrollExemptSalaryThreshold = c!.payrollExemptSalaryThreshold!;
                this.globalSettings.payrollSplitAccounts = c!.payrollSplitAccounts!.replace(/\s/g, '').split(',');

                this.globalSettings.specialAccounts.gainLossToLease = c!.specialAccountsGainLossToLease!;
                this.globalSettings.specialAccounts.gpr = c!.specialAccountsGpr!;
                this.globalSettings.specialAccounts.vacancyLoss = c!.specialAccountsVacancyLoss!;
                localStorage.setItem('budgetYear', c.budgetYear!.toString());
                console.log('System config');
                console.log(this.globalSettings);
              }
            ),
            shareReplay(1)
          )
          .subscribe(res => this.systemConfig.next(res));
    }

    getSystemConfig() {
      return this.clientApi.getSystemConfig();
    }    

    updateSystemConfig(systemConfig: SystemConfig) {
      return this.clientApi.updateSystemConfig(systemConfig);
    }
}
